import { axiosInstance } from "../../../utils/axios_config"

export default function IntegrationDriverService() {

    this.getDrivers = async () => {
        return axiosInstance.post('Driver');
    }
}